export const LOAD_NOTIFICATIONS = '[NOTIFICATIONS] LOAD_NOTIFICATIONS'
export const CHANGE_HAS_MORE = '[NOTIFICATIONS] CHANGE_HAS_MORE'
export const CHANGE_LOADING = '[NOTIFICATIONS] CHANGE_LOADING'
export const READ_ALL = '[NOTIFICATIONS] READ_ALL'
export const READ_ONE = '[NOTIFICATIONS] READ_ONE'
